'use client';
import { FC } from 'react';

import { useConsent, OPTIMIZELY_NAME } from '@lichtblick/consent';

/** Why is this isAllowed even necessary - shouldn't it be handled by usercentrics already?
 *
 * When navigating e.g. from www.lichtblick.de/ to www.lichtblick.de/zuhause/solar/, Next.js doesn't do a hard page
 * reload. Instead it's rendered client-side.
 *
 * Because of this, usercentrics doesn't recognise that a new (optimizely)
 * script has appeared.
 *
 * Thus it doesn't activate the script although the user might have given their consent. This logic tries fix that.
 */

/**
 * Not Cisco WEBEX, but Optimizely Web Experimentation Script
 */
export const OptimizelyWebExScript: FC<{ optimizelyWebExToken: string }> = ({ optimizelyWebExToken }) => {
  const isAllowed = useConsent(OPTIMIZELY_NAME);

  return (
    isAllowed && (
      <script
        async
        data-testid="optimizely-script"
        data-usercentrics="Optimizely"
        src={`https://cdn.optimizely.com/js/${optimizelyWebExToken}.js`}
        type="text/javascript"
      />
    )
  );
};
